module.exports = __webpack_public_path__ + "img/login-logo.823aef69.png";